<template>
	<transition name="slide-fade">
		<div v-if="show" class="user-list-drawer">
			<div class="user-list-header">
				<div v-text="label" />
				<CloseIcon @click="close" class="pointer close-icon" />
			</div>
			<div class="user-list-divider"></div>
			<div class="users-list">
				<div
					v-for="user in users"
					@click="onClickUser(user)"
					class="user-item pointer"
					:key="user.id"
				>
					<ProfilePic
						:user="user"
						onlineSize="10px"
						size="24px"
						class="profile"
					/>
					<div class="user-name" v-text="user.fullname" />
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { ProfilePic } from '../common'
import { getSortedUsersByIds } from '@/store'
import { CloseIcon } from '@/icons'
import { addEscapeListener, removeEscapeListener } from '@/helpers/escape'
import { showUserModal } from '@/helpers/utils'

export default {
	name: 'UserListDrawer',
	components: { ProfilePic, CloseIcon },
	props: ['label', 'userIds', 'bubbleId'],
	data() {
		return { show: false }
	},
	emits: ['close'],
	mounted() {
		this.show = true
		this.escapeId = addEscapeListener(() => this.close())
	},
	computed: {
		users() {
			return getSortedUsersByIds(this.userIds)
		},
	},
	methods: {
		onClickUser(user) {
			showUserModal(user.id, this.bubbleId)
		},
		close() {
			this.$emit('close')
			removeEscapeListener(this.escapeId)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.user-list-drawer {
	background-color: var(--neutral-200);
	top: 0;
	right: 0;
	bottom: 0;
	width: 280px;
	position: absolute;
	padding: 24px 16px 0 16px;
	color: var(--neutral-800);
	font-family: Avenir-Medium;
	border-left: 1px solid var(--neutral-40040);
	@include max-z;
	&:focus,
	&:active {
		outline: none;
	}
	.user-list-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.users-list {
		padding: 16px 0;
		max-height: calc(100% - 40px);
		overflow-y: scroll;
		.user-item {
			padding: 8px 0;
			display: flex;
			align-items: center;
			.profile {
				flex-shrink: 0;
			}
			.user-name {
				margin-left: 8px;
				font-size: 14px;
				overflow: hidden;
				width: 100%;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
		}
	}
}

.user-list-divider {
	width: 100%;
	height: 0;
	border-top: solid 1px var(--neutral-40040);
	margin-top: 16px;
}

.close-icon {
	font-size: 24px;
	color: gray;
}
</style>
